import React from 'react'
import { Dialog } from 'primereact/dialog'
import closeIcon from '../../assets/images/icon-close-alert.png'
import './index.scss'
import { t } from 'i18next'

const CancelBookingModal = ({
    displayPopUp,
    setDisplayPopUp,
    content,
    onCancelBooking
}) => {
    const closeDialog = () => {
        setDisplayPopUp(false)
    }

    const handleCancelBooking = () => {
        setDisplayPopUp(false)
        if (onCancelBooking) onCancelBooking()
    }

    const modalFooter = (
        <div className="cancel-booking-modal__footer">
            <button
                id='dismissButton'
                className='dismiss-secondary-button'
                type='button'
                onClick={closeDialog}
            >
                {t('COMMON.DISMISS')}
            </button>
            <button
                id='cancelBookingButton'
                className='cancel-booking-button'
                type='button'
                onClick={handleCancelBooking}
            >
                {t('BKGCAN.CANCEL_BOOKING')}
            </button>
        </div>
    )

    return displayPopUp ? (
            <Dialog
                footer={modalFooter}
                visible
                closable={false}
                modal
                header={
                    <div className="cancel-booking-modal__header">
                       {t('COMMON.CANCELING_BOOKING')}
                    </div>
                }
                className='modal-dialog cancel-booking-modal__dialog'
            >
                <div className="cancel-booking-modal__content">
                    {content}
                </div>
            </Dialog>
    ) : null
}

export default CancelBookingModal